<template>
  <div class="box box-skeleton">
    <div class="box-body">
      <div class="ct-skeleton ct-skeleton-img ct-skeleton-animate-wave card-img-top"></div>
    </div>
    <div class="box-footer">
      <div class="box-info">
        <a class="title-principal">
          <div class="ct-skeleton ct-skeleton-text ct-skeleton-animate-wave"></div>
        </a>
        <span class="url-access-website"><div class="ct-skeleton ct-skeleton-text ct-skeleton-animate-wave"></div></span>
      </div>
      <div class="box-options">
        <div class="btn-circle">
          <div class="ct-skeleton ct-skeleton-avatar ct-skeleton-animate-wave"></div>
        </div>
        <div class="btn-circle">
          <div class="ct-skeleton ct-skeleton-avatar ct-skeleton-animate-wave"></div>
        </div>
        <div class="btn-circle">
          <div class="ct-skeleton ct-skeleton-avatar ct-skeleton-animate-wave"></div>
        </div>
        <div class="btn-circle">
          <div class="ct-skeleton ct-skeleton-avatar ct-skeleton-animate-wave"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonCardSite"
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SkeletonCardSite.vue